import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/Custom/GameTimeline/fallback_soccer_avatar_male.svg";

export function FallbackSoccerAvatarMaleIcon(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
